import { render, staticRenderFns } from "./pcPlatform.vue?vue&type=template&id=57cfd33f&scoped=true"
import script from "./pcPlatform.vue?vue&type=script&lang=js"
export * from "./pcPlatform.vue?vue&type=script&lang=js"
import style0 from "./pcPlatform.vue?vue&type=style&index=0&id=57cfd33f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cfd33f",
  null
  
)

export default component.exports